<div class="card-container">
    <mwp-table [tableColumns]="tableColumns" [dataSource]="tableData" [header]="header" />
</div>